<template>
  <div>
    <b-card header-bg-variant="light" :header="$t('lbl.termofuse')">
      <b-card-text>
        <span style="white-space: break-spaces">
          <p>
            {{ $t("lbl.termofuseone") }}
            <a href="https://coherent-accounting.com"
              >https://coherent-accounting.com</a
            >
            {{ $t("lbl.termofusetwo") }}
          </p>
          <ul>
            <li class="p-list">{{ $t("lbl.termofusethree") }}</li>
          </ul>
          <p>
            {{ $t("lbl.text_one") }}
            <a href="https://coherent-accounting.com"
              >https://coherent-accounting.com</a
            >
            {{ $t("lbl.text_two") }}
            <a href="https://coherent-accounting.com"
              >https://coherent-accounting.com</a
            >
            {{ $t("lbl.text_three") }}
          </p>

          <ul>
            <li class="p-list">{{ $t("lbl.gt") }}</li>
          </ul>
          <p>
            <b> {{ $t("lbl.ar1") }}</b
            >{{ $t("lbl.means") }}
          </p>
          <p>
            {{ $t("lbl.textdev") }}
            <br />
            {{ $t("lbl.textdev01") }}
            <a href="https://coherent-accounting.com"
              >https://coherent-accounting.com</a
            >{{ $t("lbl.textdev1") }}<br />
            {{ $t("lbl.textdev2") }} <br />

            {{ $t("lbl.textdev3") }}
            <a href="https://coherent-accounting.com"
              >https://coherent-accounting.com</a
            >{{ $t("lbl.throughtext") }}
            <a href="https://coherent-accounting.com">
              https://coherent-accounting.com</a
            >{{ $t("lbl.onwhich") }} <br />

            {{ $t("lbl.webbased") }}
            <a href="https://coherent-accounting.comabout">
              https://coherent-accounting.comabout</a
            >.
          </p>

          <p>
            <b> {{ $t("lbl.ar2") }} </b>{{ $t("lbl.devrights") }}<br />
            {{ $t("lbl.asits") }}
            <br />
            {{ $t("lbl.in_case") }}
          </p>
          <p>
            <b> {{ $t("lbl.ar3") }} </b> {{ $t("lbl.the_dev") }}
          </p>

          <p>
            <b> {{ $t("lbl.ar4") }} </b> {{ $t("lbl.devp") }}
          </p>
          <p>
            <b> {{ $t("lbl.ar5") }} </b>{{ $t("lbl.devpp") }}
          </p>

          <p>
            <b> {{ $t("lbl.ar6") }} </b>
            <b>
              {{ $t("lbl.modification") }}

              <br /> </b
            >{{ $t("lbl.hasright") }}
          </p>
          <p>
            <b> {{ $t("lbl.ar7") }} </b>
            <b>{{ $t("lbl.termination") }}</b>
            <br />
            {{ $t("lbl.terminate") }}
          </p>
          <p>
            <b> {{ $t("lbl.ar9") }} </b>
            <b>{{ $t("lbl.platform") }}</b>
            <br />
            {{ $t("lbl.platform1") }}
          </p>
          <p>
            <b> {{ $t("lbl.ar10") }} </b>
            <b> {{ $t("lbl.complicance") }}</b>
            <br />

            {{ $t("lbl.natural") }}
          </p>
          <p>
            <b> {{ $t("lbl.ar11") }} </b>
            <b> {{ $t("lbl.Intended") }} </b>
            <br />
            {{ $t("lbl.obliged") }}
          </p>
          <p>
            <b> {{ $t("lbl.ar12") }} </b>
            <b> {{ $t("lbl.accounts") }} </b>
            <br />
            {{ $t("lbl.event") }}
          </p>
          <p>
            <b> {{ $t("lbl.ar13") }} </b>
            <b> {{ $t("lbl.Restrictions") }}</b>
            <br />
            {{ $t("lbl.copyright") }}
          </p>
          <p>
            <b> {{ $t("lbl.ar14") }} </b>
            <b> {{ $t("lbl.usage") }}</b>
            <br />
            {{ $t("lbl.registering") }}
          </p>
          <ul>
            <li class="p-list">{{ $t("lbl.regss") }}</li>
          </ul>
          <p>
            {{ $t("lbl.reset") }}
            <a href="https://coherent-accounting.com"
              >https://coherent-accounting.com</a
            >
          </p>
          <p>
            <b> {{ $t("lbl.ar15") }} </b>
            <b> {{ $t("lbl.obligationss") }}</b>
            <br />
            {{ $t("lbl.objto") }}
          </p>
          <p>
            <b> {{ $t("lbl.ar16") }} </b>
            <b> {{ $t("lbl.single") }}</b>
            <br />
            {{ $t("lbl.usercan") }}
          </p>
          <p>
            <b> {{ $t("lbl.ar17") }} </b>
            <b> {{ $t("lbl.info") }} </b>
            <br />
            {{ $t("lbl.upon") }}
          </p>
          <p>
            <b> {{ $t("lbl.ar18") }} </b>
            <b> {{ $t("lbl.terms") }}</b>
            <br />
            {{ $t("lbl.tick") }}
          </p>
          <p>
            <b> {{ $t("lbl.ar19") }} </b>
            <b> {{ $t("lbl.accuracy") }}</b>
            <br />
            {{ $t("lbl.agrees") }}
          </p>
          <p>
            <b> {{ $t("lbl.ar20") }} </b>
            <b> {{ $t("lbl.developer") }} </b>
            <br />
            {{ $t("lbl.makes") }}
          </p>
          <p>
            <b> {{ $t("lbl.ar21") }} </b>
            <b>{{ $t("lbl.activation") }}</b>
            <br />
            {{ $t("lbl.declares") }}
          </p>
          <p>
            <b> {{ $t("lbl.ar22") }} </b>
            <b> {{ $t("lbl.contract") }}</b>
            <br />
            {{ $t("lbl.active") }}
          </p>
          <ul>
            <li class="p-list">{{ $t("lbl.limits") }}</li>
          </ul>
          <p>
            <b> {{ $t("lbl.ar23") }} </b>
            <b> {{ $t("lbl.damages") }}</b>
            <br />
            {{ $t("lbl.responsible") }}
            <a href="https://coherent-accounting.comabout"
              >https://coherent-accounting.comabout</a
            >
          </p>
          <p>
            <b> {{ $t("lbl.ar24") }} </b>
            <b> {{ $t("lbl.access") }}</b>
            <br />
            {{ $t("lbl.not") }}
          </p>
          <p>
            <b> {{ $t("lbl.ar25") }} </b>
            <b> {{ $t("lbl.unverified") }}</b>
            <br />
            {{ $t("lbl.not") }}
          </p>
          <ul>
            <li class="p-list">{{ $t("lbl.othert") }}</li>
          </ul>
          <p>
            <b> {{ $t("lbl.ar26") }} </b>
            <b> {{ $t("lbl.disputeresolution") }}</b>
            <br />
            {{ $t("lbl.dispute") }}
          </p>
          <p>
            <b> {{ $t("lbl.ar27") }} </b>
            <b> {{ $t("lbl.law") }}</b>
            <br />
            {{ $t("lbl.publish") }}
          </p>
          <p>
            <b> {{ $t("lbl.ar28") }}</b>
            <b> {{ $t("lbl.maintenance") }}</b>
            <br />
            {{ $t("lbl.tries") }}
          </p>
          <p>
            <b> {{ $t("lbl.ar29") }} </b>
            <b> {{ $t("lbl.error") }}</b>
            <br />
            {{ $t("lbl.guarantee") }}
          </p>
          <p>
            <b> {{ $t("lbl.ar30") }}</b>
            <b> {{ $t("lbl.communication") }}</b>
            <br />
            {{ $t("lbl.relation") }}
          </p>
        </span>
      </b-card-text>
    </b-card>

    <b-card header-bg-variant="light" :header="$t('lbl.termofuse-1')">
      <b-card-text>
        <span style="white-space: break-spaces">
          <p>
            {{ $t("lbl.termofuseone-1") }}
          </p>
          <ul>
            <li class="p-list">1. {{ $t("lbl.introduction") }}</li>
          </ul>
          <p>
            Welcome to {{ $t("lbl.welcome") }}
            <a href="https://coherent-accounting.com"
              >https://coherent-accounting.com</a
            >
            {{ $t("lbl.explains") }}

            <a href="https://coherent-accounting.com"
              >https://coherent-accounting.com</a
            >
          </p>

          <ul>
            <li class="p-list">2. {{ $t("lbl.cookies") }}</li>
          </ul>
          <p>
            {{ $t("lbl.cookies-para") }}
          </p>

          <ul>
            <li class="p-list">3. {{ $t("lbl.use") }}</li>
          </ul>
          <p>
            {{ $t("lbl.cookies-para-1") }}
          </p>

          <p>
            <b> {{ $t("lbl.essential") }} </b>

            {{ $t("lbl.nessary") }}
          </p>
          <p>
            <b> {{ $t("lbl.Performance") }} </b>
            {{ $t("lbl.analyze") }}
            <br />
          </p>

          <p>
            <b> {{ $t("lbl.FunctionalityCookies") }} </b>
            {{ $t("lbl.enhanced ") }}
          </p>
          <p>
            <b> {{ $t("lbl.Targeting") }} </b>
            {{ $t("lbl.advertising") }}
          </p>

          <ul>
            <li class="p-list">4. {{ $t("lbl.Consent") }}</li>
          </ul>
          <p>
            {{ $t("lbl.cookies-para-3") }}
          </p>

          <ul>
            <li class="p-list">5. {{ $t("lbl.Party") }}</li>
          </ul>
          <p>
            {{ $t("lbl.cookies-para-4") }}
          </p>

          <ul>
            <li class="p-list">6. {{ $t("lbl.Changes") }}</li>
          </ul>
          <p>
            {{ $t("lbl.cookies-para-5") }}
          </p>

          <ul>
            <li class="p-list">7. {{ $t("lbl.ContactUs") }}</li>
          </ul>
          <p>
            {{ $t("lbl.cookies-para-6") }}
          </p>
        </span>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import { BCard, BCardText } from "bootstrap-vue";

export default {
  components: {
    BCard,
    BCardText,
  },
};
</script>

<style lang="scss" scoped>
.p-list {
  font-size: 1vw;
  color: #0a64bc;
  font-weight: bold;
}
</style>
